import { ErrorTypes } from "~/modules/Router/Auth/types";
import { getSupportedChainsMessage } from "~/modules/Router/Auth/utils/getSupportedChainsMessage";

export const toConnectCommandErrorMessage = (error: ErrorTypes) => {
  if (
    error === "CantGoToAuthStatusError" ||
    error === "DismissFromWalletError"
  ) {
    return;
  }

  if (error === "ReJoinDaoNotAllowedError") {
    return `Your account is not allowed to join this community.`;
  }

  if (error === "AlreadyJoinedDaoError") {
    return `You have already joined this community. Please check the community's CIETY URL or invite code and try again.`;
  }

  if (error === "AlreadyUsedAccountError") {
    return "Your account has already been registered with CIETY. Please use a different account or log in with the same wallet you used before.";
  }

  if (error === "NotSupportedChainError") {
    return `Selected chain is not supported. ${getSupportedChainsMessage()}`;
  }

  if (error === "NotDetectedWalletError") {
    return `Cannot find MetaMask on your chrome browser. Please install MetaMask extension and try again.`;
  }

  if (error === "AlreadyProcessingFromWalletError") {
    return "If your Metamask wallet connection was not successful, Please open a new Chrome browser and retry connecting Metamask wallet.";
  }

  if (error === "DaoJoinDeficientChainsError") {
    return `Please use the wallet connected to chain.`;
  }

  return `An error occurred, please try again later. If this issue persists, contact support.`;
};
